/**
 * Copyright (c) 2018 Federico Vázquez
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software
 * and associated documentation files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or
 * substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint-disable no-param-reassign, no-console */

const css = [
  'display: block',
  'display: -webkit-box',
  '-webkit-box-orient: vertical',
  'overflow: hidden',
  'text-overflow: ellipsis',
].join('; ');

const currentValueProp = 'vLineClampValue';

function defaultFallbackFunc(el, bindings, lines) {
  if (lines) {
    let lineHeight = parseInt(bindings.arg, 10);
    if (isNaN(lineHeight)) {
      console.warn('line-height argument for vue-line-clamp must be a number (of pixels), falling back to 16px');
      lineHeight = 16;
    }

    const maxHeight = lineHeight * lines;

    el.style.maxHeight = maxHeight ? `${maxHeight}px` : '';
    el.style.overflowX = 'hidden';
    el.style.lineHeight = `${lineHeight}px`; // to ensure consistency
  } else {
    el.style.maxHeight = '';
    el.style.overflowX = '';
  }
}

function truncateText(el, bindings, useFallbackFunc) {
  const lines = parseInt(bindings.value, 10);
  if (isNaN(lines)) {
    console.error('Parameter for vue-line-clamp must be a number');
  } else if (lines !== el[currentValueProp]) {
    el[currentValueProp] = lines;

    if (useFallbackFunc) {
      useFallbackFunc(el, bindings, lines);
    } else {
      el.style.webkitLineClamp = lines || '';
    }
  }
}

const useFallbackFunc = 'webkitLineClamp' in document.body.style
  ? undefined
  : defaultFallbackFunc;

export default {
  currentValue: 0,
  bind(el) {
    el.style.cssText += css;
  },
  inserted: (el, bindings) => truncateText(el, bindings, useFallbackFunc),
  updated: (el, bindings) => truncateText(el, bindings, useFallbackFunc),
  componentUpdated: (el, bindings) => truncateText(el, bindings, useFallbackFunc),
};
